module.exports = __webpack_public_path__ + "media/images/yellow_circle_outline_opacity_right-9ede6a6149ca49c83e136b30daa2f5ae.png";